import React from "react";
import styles from "./Network.module.scss";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

// import App from './../../app/App';
import NrgPage from '../NrgPage.jsx';
// import CommonClientScripts from './../../components/CommonClientScripts.jsx';
import ContactUnderPipePanel from './../../components/ContactUnderPipePanel/ContactUnderPipePanel.jsx';
import DocumentHead from './../../components/DocumentHead.jsx';
import Footer from './../../components/Footer/Footer.jsx';
import GenericHeader from './../../components/Header/GenericHeader.jsx';
import JourneyContinueBox from './../../components/JourneyContinueBox/JourneyContinueBox.jsx';
// import NewsPanel from './../../components/NewsPanel/NewsPanel.jsx';
import PageTransitioner from '../../components/PageTransitioner.jsx';
import PipedContentFooter from './../../components/PipedContentFooter/PipedContentFooter.jsx';
import PipedContentHeader from './../../components/PipedContentHeader/PipedContentHeader.jsx';
import PipedPanelConnector from './../../components/PipedPanelConnector/PipedPanelConnector.jsx';
import SimpleTextBox from './../../components/SimpleTextBox/SimpleTextBox.jsx';
import SplitPipePanel from './../../components/SplitPipePanel/SplitPipePanel.jsx';

import ScrollItemManager from './../../utils/ScrollItemManager';
import { changePageTitle } from "../../utils/pageSetup/pageSetup";

class Network extends NrgPage {
    constructor(props) {
        super(props);

        this.page = 'network';
    }
    componentDidMount() {
        changePageTitle(this.page);

        this.scrollItemManager = new ScrollItemManager()
        this.scrollItemManager.setup()
    }
    render() {
        return (
            <div className={[this.page, "container-fluid"].join(" ")}>
                <PageTransitioner page={this.page}>

                    {/* <ReactCSSTransitionGroup
                        transitionName="news"
                        transitionAppear={true}
                        transitionAppearTimeout={0}
                        transitionEnterTimeout={300}
                        transitionLeaveTimeout={300}>
                        {newsPanel}
                    </ReactCSSTransitionGroup> */}

                    <GenericHeader page={this.page} newsActions={this.newsActions} />

                    <SimpleTextBox page={this.page} />

                    <PipedContentHeader page={this.page} section="offices" />

                    <div className="row offices">
                        <div className="col-xs-16 col-md-5plus">
                            <SplitPipePanel page={this.page} office="la" />
                        </div>
                        <div className="col-xs-16 visible-xs-block visible-sm-block">
                            <PipedPanelConnector />
                        </div>
                        <div className="col-xs-16 col-md-5plus">
                            <SplitPipePanel page={this.page} office="ny" />
                        </div>
                        <div className="col-xs-16 visible-xs-block visible-sm-block">
                            <PipedPanelConnector />
                        </div>
                        <div className="col-xs-16 col-md-5plus">
                            <SplitPipePanel page={this.page} office="london" />
                        </div>
                        <div className="col-xs-16 visible-xs-block visible-sm-block">
                            <PipedPanelConnector />
                        </div>
                        <div className="col-xs-16 col-md-5plus">
                            <SplitPipePanel page={this.page} office="si" />
                        </div>
                    </div>

                    <PipedContentFooter />

                    <PipedContentHeader page={this.page} section="network" />
                    <ContactUnderPipePanel page={this.page} section="network" />
                    <PipedContentFooter section="network" />

                    <JourneyContinueBox nextPage="News" nextPageHref="/news" />

                    <Footer />

                </PageTransitioner>
            </div>
        );
    }
}

export default Network;
